import React from 'react';
import { CountryWithSource } from '../../atoms/CountryWithSource';
import { TailwindTooltip } from '../../atoms/TailwindTooltip';

export interface CountrySourceWithTooltipProps {
	countryAlpha: string;
	countryName: string;
	dataSourceShortName: string;
	dataSourceDescription?: string;
}

export function CountrySourceWithTooltip({
	countryAlpha,
	countryName,
	dataSourceShortName,
	dataSourceDescription,
}: CountrySourceWithTooltipProps) {
	return (
		<TailwindTooltip
			reference={
				<CountryWithSource
					countryAlpha={countryAlpha}
					countryName={countryName}
					dataSourceShortName={dataSourceShortName}
					showTooltip={true}
				/>
			}
			displayClass='w-full group'
			position='right'
		>
			<p className='leading-snug text-[12px]'>
				<strong className='block mb-1.5 text-[14px] not-italic'>{countryName}</strong>
				<strong className='mr-1'>{dataSourceShortName}</strong>
				{dataSourceDescription}
			</p>
		</TailwindTooltip>
	);
}
